import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	yAxisLabelDays: {
		id: 'software-cycle-time-breakdown-report.historical-cycle-time.chart.y-axis-label-days',
		defaultMessage: 'Median Cycle time (Days)',
		description: 'Y axis label indicating y axis value is average cycle time in days',
	},
	yAxisLabelHours: {
		id: 'software-cycle-time-breakdown-report.historical-cycle-time.chart.y-axis-label-hours',
		defaultMessage: 'Median Cycle time (Hours)',
		description: 'Y axis label indicating y axis value is average cycle time in hours',
	},
});
